<template>
  <view class="coupon-item">
    <view class="coupon-left">
      <text class="amount">￥{{ discountAmount }}</text>
      <text class="coupon-type">{{ couponType }}</text>
    </view>
    <view class="coupon-right">
      <view class="coupon-name">{{ couponName }}</view>
      <view class="discount-content">{{ discountContent }}</view>
      <view class="end-time">{{ endTime }}前使用</view>
    </view>
  </view>
</template>

<script>
export default {
  name: 'CouponItem',
  props: {
    couponType: {
      // 卡券类型
      type: String,
      default: '',
    },
    discountAmount: {
      // 优惠券额度
      type: Number,
      default: 0,
    },
    discountContent: {
      // 优惠内容
      type: String,
      default: '',
    },
    endTime: {
      // 截止时间
      type: String,
      default: '',
    },
    couponName: {
      // 卡券名称
      type: String,
      default: '',
    },
  },
};
</script>

<style scoped lang="scss">
.coupon-item {
  width: 100%;
  height: auto;
  border-radius: 10rpx;
  position: relative;
  display: flex;
  flex-direction: row;
  overflow: hidden;
  .coupon-left {
    width: 100px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    background-color: #f33;
    color: #fff;
    padding: 10px 0;
    .amount {
      text-align: center;
      font-size: 36rpx;
    }
    .coupon-type {
      text-align: center;
      font-size: 26rpx;
    }
  }
  .coupon-right {
    padding: 10px;
    flex: 1;
    background-color: #fff;
    border: 1px solid #eeeeee;
    .discount-content {
    }
    .end-time {
    }
  }
}
.coupon-item:after {
  width: 20rpx;
  height: 20rpx;
  position: absolute;
  left: 95px;
  top: -5px;
  border-radius: 0 0 20rpx 20rpx;
  content: '';
  display: block;
  background: #fff;
  border: 1px solid #eeeeee;
  border-top: 0px;
}
.coupon-item:before {
  width: 20rpx;
  height: 20rpx;
  position: absolute;
  left: 95px;
  bottom: -5px;
  border-radius: 20rpx 20rpx 0 0;
  content: '';
  display: block;
  background: #fff;
  border: 1px solid #eeeeee;
  border-bottom: 0px;
}
</style>
